module.exports = __webpack_public_path__ + "joy-static/media/StreakIcon.a19802d7.png";